import { FC } from 'react';
import styled from "styled-components";

import constants from "../../_globalStyles/constants";

import Box, { BoxProps } from '../../particles/Box';

export const FinnBoxStyled: FC<BoxProps> = styled(Box)`
position: relative;
max-width: ${constants.GRID_UNIT * 128}px;
margin: 0 auto;
`
